import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { chatQuestionsService } from '../services/chat.questionsService';

export const getAllChatQuestions = createAsyncThunk(
  'chatQuestions/getAllChatQuestions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await chatQuestionsService.getAllChatQuestionsREST();
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getQuestionsByCategory = createAsyncThunk(
  'chatQuestions/getQuestionsByCategory',
  async (category, { rejectWithValue }) => {
    try {
      const response = await chatQuestionsService.getQuestionsByCategoryREST(category);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const chatQuestionsSlice = createSlice({
  name: 'chatQuestions',
  initialState: {
    questions: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllChatQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllChatQuestions.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload;
      })
      .addCase(getAllChatQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getQuestionsByCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getQuestionsByCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.questions = action.payload;
      })
      .addCase(getQuestionsByCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = chatQuestionsSlice.actions;

export default chatQuestionsSlice.reducer;
